<template>
  <div class="guide-wrap" v-if="configure && featureList">
    <div class="steps">
      <el-row>
        <el-col :span="5">需要欢迎的人</el-col>
        <el-col :span="19">
          <el-checkbox-group v-model="checkList">
            <el-checkbox
              v-for="item in welcomeConfig"
              :key="item.value"
              :label="item.value"
              >{{ item.label }}</el-checkbox
            >
          </el-checkbox-group>
          <div class="row-padding">
            <el-checkbox-group v-model="whiteidCon" @change="whiteidConChange">
              <el-checkbox label="welcomeHasBadge">有牌贵宾席白号</el-checkbox>
              <el-checkbox label="welcomeNoBadge">无牌贵宾席白号</el-checkbox>
              <el-checkbox
                v-if="whiteidEnable"
                label="welcomeTourist"
                >游客白号<a
                  href="//www.xiaohudi.com/entry/2.html"
                  target="_blank"
                  style="margin-left: 10px"
                  ><i class="fa-question-circle"></i></a
              ></el-checkbox>
            </el-checkbox-group>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">需要感谢的礼物</el-col>
        <el-col :span="19">
          <div class="row-padding">
            <el-radio v-model="configure.giftTks.giftTks1.tksAll" label="1"
              >&nbsp;</el-radio
            >感谢所有礼物
          </div>
          <div class="row-padding">
            <el-radio v-model="configure.giftTks.giftTks1.tksAll" label="0"
              >&nbsp;</el-radio
            >只感谢金额≥
            <el-input-number
              v-model="configure.giftTks.giftTks1.money"
              :controls-position="isWeixin ? '' : 'right'"
              :min="0"
              size="mini"
              :precision="1"
            ></el-input-number
            >块钱的礼物
            <!-- <br />
          <strong style="margin-left:18px;">或</strong> 数量≥
          <el-input-number
            v-model="configure.giftTks.giftTks1.count"
            controls-position="right"
            :min="0"
            size="mini"
            :precision="0"
          ></el-input-number
          >的免费礼物 -->
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">你喜欢的词库风格</el-col>
        <el-col :span="19">
          <el-radio-group
            v-model="configure.global.thesaurus"
            size="small"
            @change="thesaurusChange"
          >
            <el-radio-button label="man">朴素风格</el-radio-button>
            <el-radio-button label="girl">花式风格</el-radio-button>
          </el-radio-group>
          <q>
            <p>
              <el-tag
                :type="configure.global.thesaurus == 'man' ? '' : 'info'"
                size="mini"
                >朴素</el-tag
              >欢迎 小虎弟
            </p>
            <p>
              <el-tag
                :type="configure.global.thesaurus == 'girl' ? '' : 'info'"
                size="mini"
                >花式</el-tag
              >小虎弟来了，欢迎欢迎、日久生情 ♥
            </p>
          </q>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">主播昵称</el-col>
        <el-col :span="19">
          <el-input
            class="anchor-nickname"
            size="medium"
            v-model.trim="configure.global.anchorNick"
            placeholder="请输入主播昵称"
          ></el-input>
          的直播间
        </el-col>
      </el-row>
      <!-- <div class="button-row footer">
      <el-button size="mini" icon="el-icon-back" @click="backToAccout">上一步</el-button>
      <el-button size="mini" icon="el-icon-right" type="primary" @click="save">下一步</el-button>
    </div> -->
    </div>
    <div class="bottom-actions">
      <button class="button plain" @click="backToAccout">上一步</button>
      <button class="button" @click="save">完成</button>
    </div>
  </div>
</template>

<script>
import {
  userInfo,
  getConfig,
  getFeatureList,
  updateConfig,
  getFeatureWords,
  setGuide,
} from "@/api/index";
import { deepObjectMerge } from "@/utils/object";
import { Message } from "element-ui";
import { mapState } from "vuex";
import { commonFuc } from "@/mixins/commonFuc";
export default {
  mixins: [commonFuc],
  data() {
    return {
      featureList: null, // 功能商品列表
      configure: null,
      cloud: {
        user: null,
        enable: false,
      },
      checkList: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      welcomeConfig: [
        {
          value: 1,
          label: "剑士",
        },
        {
          value: 2,
          label: "骑士",
        },
        {
          value: 3,
          label: "领主",
        },
        {
          value: 4,
          label: "公爵",
        },
        {
          value: 5,
          label: "君王",
        },
        {
          value: 6,
          label: "帝皇",
        },
      ],
      // 小白号配置
      whiteidCon: [],
      accountList: {},
    };
  },
  computed: {
    ...mapState({
      isWeixin: (state) => state.isWeixin,
    }),
  },
  watch: {
    checkList(val) {
      console.log(val);
    },
  },
  created() {
    this.accountList = localStorage["accountList"]
      ? JSON.parse(localStorage["accountList"])
      : {};
    userInfo(null, { notify: false }).then((res) => {
      if (res.code == -2050) {
        localStorage.removeItem("sid");
        this.$router.replace("/login");
      } else {
        this.user = res.data;
        this.ticket = res.data.ticket;
        this.getConfig();
      }
    });
  },
  methods: {
    getConfig() {
      getConfig(
        {
          ticket: this.ticket,
        },
        { notify: false }
      ).then((res) => {
        if (res.code == 0) {
          const configure = res.data.configure;
          let d = JSON.parse(configure);
          if (this.configure == null) {
            this.configure = d;
          } else {
            Object.assign(this.configure, d);
          }
          this.configure.features = res.data.features;
          this.getFeaturList();
        }
      });
    },
    getFeaturList() {
      getFeatureList(null, { notify: false }).then((res) => {
        if (res.code == 0) {
          const featureList = res.data.featureList;
          let featureListObject = {};
          this.featureList = {};
          featureList.forEach((val, index) => {
            this.featureList[val.jsonField] = val;
            this.featureList[val.jsonField].isBuy = this.configure.features[val.jsonField]
              ? true
              : false;
            this.featureList[val.jsonField].timeRemaining = Math.ceil(
              (this.configure.features[val.jsonField] * 1000 - +new Date()) / 86400000
            );
            if (val.jsonField == "global") {
              let defaultData = JSON.parse(val.defaultData);
              defaultData.liveRoomUrl = this.configure.global.liveRoomUrl;
              defaultData.liveRoomName_config = this.configure.global.liveRoomName_config;
              defaultData.anchorNick = this.configure.global.anchorNick;
              val.defaultData = JSON.stringify(defaultData);
            }
            if (val.jsonField == "keyPerson") {
              let defaultData = JSON.parse(val.defaultData);
              defaultData.list = this.configure.keyPerson.list;
              val.defaultData = JSON.stringify(defaultData);
            }
            featureListObject[val.jsonField] = val;
            if (this.configure[val.jsonField]) {
              this.configure[val.jsonField] = deepObjectMerge(
                JSON.parse(val.defaultData),
                this.configure[val.jsonField]
              );
            } else {
              this.$set(
                this.configure,
                val.jsonField,
                deepObjectMerge({}, JSON.parse(val.defaultData))
              );
            }
          });
          if (this.configure.welcome.welcomeNoBadge) {
            this.whiteidCon.push("welcomeNoBadge");
          }
          if (this.configure.welcome.welcomeTourist) {
            this.whiteidCon.push("welcomeTourist");
          }
          if (this.configure.welcome.welcomeHasBadge) {
            this.whiteidCon.push("welcomeHasBadge");
          }
        }
      });
    },
    thesaurusChange(val) {
      if (!this.thesaurusWords) {
        getFeatureWords({ notify: false }).then((res) => {
          if (res.code === 0) {
            this.thesaurusWords = res.data.words;
            this.changeThesaurusConfirm(val);
          }
        });
      } else {
        this.changeThesaurusConfirm(val);
      }
    },
    changeThesaurusConfirm(val) {
      if (!this.isShowGuide) {
        this.$confirm(
          `即将载入${
            val == "girl" ? "花式词库" : "朴素词库"
          }，如果有自己配置过的句子会被覆盖`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then((action) => {
            if (action == "confirm") {
              if (val === "girl") {
                for (let item in this.thesaurusWords.female) {
                  for (let subitem in this.thesaurusWords.female[item]) {
                    this.configure[item][subitem].tpl = JSON.parse(
                      JSON.stringify(this.thesaurusWords.female[item][subitem].tpl)
                    );
                  }
                }
              }
              if (val === "man") {
                for (let item in this.thesaurusWords.male) {
                  for (let subitem in this.thesaurusWords.male[item]) {
                    this.configure[item][subitem].tpl = JSON.parse(
                      JSON.stringify(this.thesaurusWords.male[item][subitem].tpl)
                    );
                  }
                }
                this.configure.giftTks.giftTksPreWords.preEnable = false;
              }
              this.configure.global.thesaurus = val;
            }
          })
          .catch((error) => {
            if (error == "cancel") {
              if (val === "girl") {
                this.configure.global.thesaurus = "man";
              } else {
                this.configure.global.thesaurus = "girl";
              }
              setTimeout(() => {
                this.isChange = false;
              }, 0);
            }
          });
      }
    },
    save() {
      this.configure.welcome.welcome1.level = [];
      this.configure.welcome.welcome2.level = [];
      this.checkList.forEach((val) => {
        if (val < 4 || val > 7) {
          this.configure.welcome.welcome1.level.push(val);
        } else {
          this.configure.welcome.welcome2.level.push(val);
        }
      });
      updateConfig({
        configure: JSON.stringify(this.configure),
        ticket: this.ticket,
      }).then((res) => {
        if (res.code == 0) {
          this.linkToRobotManager();
        }
      });
    }, // 保存配置
    whiteidConChange(val) {
      this.configure.welcome.welcomeNoBadge = !!~val.indexOf("welcomeNoBadge");
      this.configure.welcome.welcomeTourist = !!~val.indexOf("welcomeTourist");
      this.configure.welcome.welcomeHasBadge = !!~val.indexOf("welcomeHasBadge");
    }, //小白号选择
    backToAccout() {
      this.$router.replace("/guideAccount");
    },
    linkToContent() {
      localStorage.setItem("guidePage", "/guideContent");
      this.$router.replace({
        path: "/guideContent",
      });
    },
    linkToRobotManager() {
      setGuide({
        guide: 0,
      }).then((res) => {
        if (res.code == 0) {
          localStorage.removeItem("guidePage");
          this.$router.replace({
            name: "robotManager",
            params: {
              type: "guide",
            },
          });
        }
      });
    },
  },
};
</script>
